import { useState, useCallback } from 'react';
import { Modal, TextField, Button, Spinner, Text } from '@shopify/polaris';

export default function AiTextProcessingModal({ active, setActive, onProcessText, isProcessing = false }) {
  const [textInput, setTextInput] = useState('');

  const handleModalClose = useCallback(() => {
    setActive(false);
    setTextInput('');
  }, [setActive]);

  const handleProcessText = useCallback(async () => {
    if (textInput.trim()) {
      await onProcessText(textInput.trim());
      handleModalClose();
    }
  }, [textInput, onProcessText, handleModalClose]);

  const handleTextChange = useCallback((value) => {
    setTextInput(value);
  }, []);

  return (
    <Modal
      open={active}
      onClose={handleModalClose}
      title="Process Text to Lines"
      primaryAction={{
        content: 'Process Text',
        onAction: handleProcessText,
        disabled: !textInput.trim() || isProcessing,
        loading: isProcessing
      }}
      secondaryActions={[
        {
          content: 'Cancel',
          onAction: handleModalClose,
          disabled: isProcessing
        }
      ]}
      large
    >
      <Modal.Section>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <Text variant="bodyMd" as="p">
            Paste your text below. The AI will attempt to extract product information and convert it to structured line data.
          </Text>

          <TextField
            label="Text to Process"
            value={textInput}
            onChange={handleTextChange}
            multiline={8}
            placeholder="Paste your text here... For example:&#10;2x Product A - €25.50&#10;1x Product B - €15.00&#10;3x Product C - €10.25"
            disabled={isProcessing}
            autoComplete="off"
          />

          {isProcessing && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Spinner size="small" />
              <Text variant="bodyMd" as="span">
                Processing text with AI...
              </Text>
            </div>
          )}
        </div>
      </Modal.Section>
    </Modal>
  );
}
